import { useParams } from '@tanstack/react-router';
import { comparer, computed } from 'mobx';
import { observer } from 'mobx-react-lite';

import { tabStore } from '@/features/tabs';

import { ChatBrowserStreamPanel } from './ChatBrowserStreamPanel';

const openThreadIds = computed(
  () => {
    const ids = new Set<string>();
    for (const tab of tabStore.tabs) {
      const match = /^\/chats\/([^/]+)$/.exec(tab.route.path);
      if (match) ids.add(match[1]);
    }
    return [...ids];
  },
  { equals: comparer.structural }
);

// Keep the iframe in the layout, outside the keyed chat route
export const BrowserStreamPanels = observer(() => {
  const chatId = useParams({
    strict: false,
    select: (params) => params.chatId,
  });
  const ids = openThreadIds.get();
  const threadIds = chatId && !ids.includes(chatId) ? [...ids, chatId] : ids;

  return threadIds.map((threadId) => (
    <ChatBrowserStreamPanel
      key={threadId}
      threadId={threadId}
      isSelected={threadId === chatId}
    />
  ));
});
